var configProd = {
  apiKey: "AIzaSyAvPENGml1zGJylRqs1TdvdHhsrx3jo5SU",
  authDomain: "wellings-prod.firebaseapp.com",
  databaseURL: "https://wellings-prod.firebaseio.com",
  projectId: "wellings-prod",
  storageBucket: "wellings-prod.appspot.com",
  messagingSenderId: "197010889173"
};

export default configProd;
